import Suggestion from "./Suggestion";
export default Suggestion;
